import { useState } from 'react'
import { Modal, message } from 'antd'
import type { Settlement } from '../types/settlement.types'
import { formatINR } from '../../../shared/utils/formatters'

export const useSettlementActions = () => {
    const [selectedSettlement, setSelectedSettlement] = useState<Settlement | null>(null)
    const [isDetailDrawerOpen, setIsDetailDrawerOpen] = useState(false)

    const handleViewDetails = (settlement: Settlement) => {
        setSelectedSettlement(settlement)
        setIsDetailDrawerOpen(true)
    }

    const handleProcessSettlement = (settlement: Settlement) => {
        // We use string concatenation instead of JSX to avoid .ts file errors
        Modal.confirm({
            title: 'Process Settlement',
            content: `Process settlement ${settlement.id} for ${settlement.merchant}? Net amount: ${formatINR(settlement.netAmount)}`,
            okText: 'Process',
            onOk: () => {
                message.success(`Settlement ${settlement.id} processed successfully!`)
                setIsDetailDrawerOpen(false)
            },
        })
    }
    
    const closeDrawer = () => setIsDetailDrawerOpen(false)

    return {
        selectedSettlement,
        isDetailDrawerOpen,
        handleViewDetails,
        handleProcessSettlement,
        closeDrawer
    }
}
